import { render, staticRenderFns } from "./PersonalInfoCollectContent.vue?vue&type=template&id=36b0c1d2&scoped=true"
import script from "./PersonalInfoCollectContent.vue?vue&type=script&lang=js"
export * from "./PersonalInfoCollectContent.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoCollectContent.vue?vue&type=style&index=0&id=36b0c1d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b0c1d2",
  null
  
)

export default component.exports